import { lang } from "./lang";

export default {
  ...lang,
};

export const Icons = {
  IMAGE_EXTENSTION: ".svg",
  HOME_LOGO: "new-big-logo-mv",
  LOGIN_BANNER: "login-banner",
  LIST_LOCK_OPEN: "lock-open",
  LIST_LOCK: "lock",
  IC_USER: "ic-user",
  CLOSE_IMAGE: "ic-close",
  ICON_REVIEW_APPROVE: "icon-review-approve",
  ICON_REVIEW_REJECT: "icon-review-reject",
  IC_BACK_ARROW: "ic-back-arrow",
  IC_REJECT_INFO: "ic-reject-info",
  IC_LOG_OUT: "logout",
  IC_ERROR: "ic-error",
  IC_REFRESH: "ic-refresh",
  IC_PAGE_NOT_FOUND: "ic-page-not-found",
  IC_NO_PAGE_ACCESS: "ic-error",
  IC_FILTER: "ic-filter",
  IC_FILTER_SELECTED: "ic-filter-selected",
  CHECK_CIRCLE_DONE_NEW: "check-circle-done-new",
  IC_REVERT_TO_ORIGINAL: "",
  IC_EDIT_IMAGE: "ic-edit-image",
  IC_REPLACE_IMAGE: "ic-replace",
  IC_ADD_DOCUMENT: "ic-add-document",
  IC_SQUARE_WARNING: "ic_square_warning_v1",
  IC_USER_AVATAR_V1: "ic-user-avatar-placeholder",
};

export const InputType = {
  RADIO: "radio",
  RADIO_LABEL: "radioLabel",
  INPUT: "input",
  BUTTON: "button",
  DATE: "date",
  CHECKBOX: "checkbox",
  // new checkbox type for filters to have separate key with filterId in request.
  CHECKBOX_V2: "checkboxV2",
  LINK: "link",
  SEARCH: "search",
  SELECT: "select",
  AUTOCOMPLETE: "autoComplete",
  BUTTON_CHECKBOX_GROUP: "buttonCheckboxGroup",
  BUTTON_RADIO_GROUP: "buttonRadioGroup",
  BUTTON_RADIO_DATE_GROUP: "buttonRadioDateGroup",
  RANGE_SLIDER: "rangeSlider",
  ACCORDION_GROUP: "accordionGroup",
  INPUT_TYPE_GROUP: "inputGroup",
  FILE: "file",
};



export const GRID_HEADERS = {
  FD_ID: "FDeskID",
  SR_ID: "SR ID",
  NAME_EMAIL:"Name and Email",
  CATEGORY: "Category",
  STATUS: "Status",
  UPDATES: "Updates",
  MODIFIED_BY: "Modified By",
  ACTION: "Action",
  TRANSACTION_ID: "Transaction ID",
  PAYEE: "Payee",
  AMOUNT: "Amount",
  MODE: "Mode",
  DATE: "Date",
  REASON_REMARKS: "Reasons/Remarks",
};


export const COLUMN_KEY = {
  FD_ID: "fdId", 
  SR_ID: "srId",
  USER_NAME: "userName",
  EMAIL: "email",
  CATEGORY: "category",
  STATUS: "status",
  UPDATES: "updates",
  MODIFIED_BY: "modifiedBy",
  AGENT_MODIFIED_DATE: "agentModifiedDate",
  ACTION: "action",
  IS_ACTION: "isAction",
  IS_ACTIONABLE: "isActionable",
  IS_LINK: "isLink",
  TRANSACTION_ID: "txnId",
  PAYEE: "payee",
  AMOUNT: "amount",
  MODE: "txnMode",
  DATE: "txnDate",
  REASON_REMARKS: "remark",
};

export const SORT_ORDER = {
  DESC: "desc",
  ASC: "asc",
};

export const ERROR = {
  SERVER_ERROR_MESSAGE: "Data not loaded due to some server error",
  TRY_AGAIN: "Please try again",
  PAGE_NOT_FOUND: "Oops! Page Not found",
  PAGE_NOT_FOUND_MESSAGE: "We are sorry but the page you are looking for doesn’t exist or has been moved",
  NO_PAGE_ACCESS: "Sorry! You don't have access to this page",
  NO_PAGE_ACCESS_MESSAGE: "You don't have permission to access this page. Please contact administrator.",
  BACK_TO_HOME: "Back to Homepage",
  SOMETHING_WRONG_MESSAGE: "We're sorry, something went wrong",
  LOADING_SERVER_MESSAGE: "An error occur while loading page. Try Reloading the page again",
};
export const SEARCH_LIST = {
  SEARCH_TEXT: "searchValue",
  SEARCH_BY: "searchColumn",
};



export const PAGE_TITLE = {};

export const SNACKBAR_TYPE = {
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  SUCCESS: "success",
};

export const FILTER_ACTIONS = {
  QUEUE_TYPE: "QUEUE_TYPE",
  RESET: "RESET",
  SUB_QUEUE: "SUB_QUEUE",
  APPLY: "APPLY",
  CANCEL: "CANCEL",
};



export const TABLE_COLUMN_ACTION = {
  VIEW_SR_DETAILS: "VIEW_SR_DETAILS",
  SAVE: "SAVE",
  CALL: "CALL",
};

export const SELECT_OPTIONS = {
  CASE_STATUS: "Select Case Status",
};

export const TABLE_ACTION_TYPES = {
  LINK: "link",
  STATUS_BUTTON: "statusButton",
  INPUT_ACTION: "inputAction",
};

export const portalType = {
  CRM: "CRM",
};

export const modelFields = {
  AGENT_SEARCH: "AGENT_SEARCH",
  AGENT_LIST_ACTION: "AGENT_LIST_ACTION",
  AGENT_LIST_CANCEL: "AGENT_LIST_CANCEL",
  AGENT_LIST_CONTINUE: "AGENT_LIST_CONTINUE",
};

export const fieldValidationTypes = {
  POSITIVE_NUMBER: "POSITIVE_NUMBER",
  MOBILE_NUMBER: "MOBILE_NUMBER",
};

export const dateFormat = {
  formatClient: "DD MMM YYYY",
  formatClientV2: "DD/MM/YYYY",
  formatClientV3: "DD-MM-YYYY",
  formatServer: "YYYY-MM-DD",
  formatDateTimeServer: "YYYY-MM-DD HH:mm:ss",
  formatClientDateTime: "DD MMM YYYY hh:mm A",
};

export const portalFor = {
  AGENCY: "agency",
  OPS: "ops",
};

